module.exports = __webpack_public_path__ + "img/nav_bg.49d8443e.jpg";